export default "__VITE_ASSET__BbuLp0v6__"